import React from "react";
export const Bio = () => {
	return (
		<div id='about'>
			<div className='container'>
				<div className='title-container'>
					<h2 className='section-title'>About Me</h2>
					<div className='title-line'></div>
					<div></div>
				</div>

				<p className='about-paragraph'>
					I am a Graduate Software Developer eager to embark on a
					rewarding career in the field of software development. My
					journey into this domain began when I engaged in a five-day
					coding challenge organised by the esteemed Coding Institute.
					During this coding challenge, I successfully created a
					comprehensive website that provides a guide on how to
					prepare tea. This project marked the inception of my foray
					into the world of coding and software development, and it
					was during this endeavour that I discovered my profound
					enjoyment and passion for creating innovative projects.
					Seeking to increase my skills and knowledge further, I
					 participated in the renowned Northcoders coding
					bootcamp, a three-month immersive program characterised by
					rigorous learning and practical experience. Throughout this
					bootcamp, I delved deeply into the intricacies of JavaScript
					and familiarized myself with several associated frameworks,
					thereby fortifying my technical acumen. Now, as I stand at
					the threshold of my career, I am eager to secure my first
					professional position and contribute significantly to a
					progressive company. I am ardent about applying my expertise
					and skills to add substantial value to a team, while also
					gaining valuable commercial experience to further refine my
					capabilities.
				</p>
			</div>
		</div>
	);
};
